<div class="image-popup">
    <span class="close-btn" (click)="closePopup()">X</span>
    <img [src]=" AssetbasePath + '/Content/BImages/mountingPosition.gif'">
</div>
  